import instance, { customConfigFormData } from "../../../Utils/Interceptors/Interceptor";

const SolicitudReprocesoService = async (values) => {
	try {
		const formData = new FormData();
		formData.append("idUsuarioCreacion", values.idUsuarioCreacion);
		formData.append("anio", values.anio);
		formData.append("mes", values.mes);

		(values.listaArchivos || []).forEach((archivo) => {
			formData.append("ListaArchivos", archivo);
		});

		(values.detalleReprocesoEventos || []).forEach((evento, index) => {
			formData.append(`DetalleReprocesoEventos[${index}].EventoConcesionId`, evento.eventoConcesionId);
			formData.append(`DetalleReprocesoEventos[${index}].EstadoEventoSolicitado`, evento.estadoEventoSolicitado);
			formData.append(`DetalleReprocesoEventos[${index}].EstadoAutorizacionSolicitado`, evento.estadoAutorizacionSolicitado);
			formData.append(`DetalleReprocesoEventos[${index}].Observacion`, evento.observacion);
		});

		return await instance.Backend.post("/Indicador/SolicitudReproceso", formData, customConfigFormData);
	} catch (error) {
		console.log(error);
	}
};

export { SolicitudReprocesoService };
